import { Controller } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { Spacing } from '@zep/ui';
import { Tabs, TabsContent, TabsList } from '@zep/ui/experimental';
import { usePlanPaymentFormContext, usePlanPaymentInfoContext } from '../../PlanPaymentSection/Providers';
import { PlanTemplateType } from '../../types';
import { PlanTabsTrigger } from '../PlanTypeSelector/PlanTabsTrigger';
import { DisabledTabsContent } from './DisabledTabsContent';
import { OnetimeTabsContent } from './OnetimeTabsContent';
import { SubscriptionTabsContent } from './SubscriptionTabsContent';
export const PlanDurationSelector = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    control,
    watch,
    formState: {
      defaultValues
    }
  } = usePlanPaymentFormContext();
  const {
    currentOperationType
  } = usePlanPaymentInfoContext();
  const maxCcu = watch('maxCcu');
  return <div className="flex w-full flex-col items-start" data-sentry-component="PlanDurationSelector" data-sentry-source-file="PlanDurationSelector.tsx">
      <h2 className="text-[17px] font-[700] text-gray-900">
        {t('subscription:payment.duration.subTitle', '이용 기간')}
      </h2>
      <Spacing size={14} data-sentry-element="Spacing" data-sentry-source-file="PlanDurationSelector.tsx" />
      <div className="flex w-full flex-col items-center">
        <Controller control={control} name="planTemplateType" defaultValue={defaultValues?.planTemplateType} render={({
        field
      }) => {
        return <Tabs className="w-full" defaultValue={field.value} onValueChange={field.onChange}>
                <div className="flex w-full justify-center">
                  {currentOperationType == null && <TabsList className="flex w-full flex-row items-center gap-px rounded-[8px] border border-[#27262E0A] p-[2px]">
                      <PlanTabsTrigger className="h-[36px]" value={PlanTemplateType.PRODUCT_SUBSCRIPTION}>
                        {t('subscription:payment.duration.subscribe', '정기 구독할래요')}
                      </PlanTabsTrigger>
                      <PlanTabsTrigger className="h-[36px]" value={PlanTemplateType.PRODUCT_ONETIME}>
                        {t('subscription:payment.duration.lumpSum', '원하는 기간만 구매할래요')}
                      </PlanTabsTrigger>
                    </TabsList>}
                </div>
                <Spacing size={8} />
                <TabsContent value={PlanTemplateType.PRODUCT_SUBSCRIPTION} className="m-0">
                  {maxCcu >= 300 ? <DisabledTabsContent /> : <SubscriptionTabsContent />}
                </TabsContent>
                <TabsContent value={PlanTemplateType.PRODUCT_ONETIME} className="m-0">
                  <OnetimeTabsContent />
                </TabsContent>
              </Tabs>;
      }} data-sentry-element="Controller" data-sentry-source-file="PlanDurationSelector.tsx" />
      </div>
    </div>;
};